// extracted by mini-css-extract-plugin
export default {"text":"greyText_text__M6zQT"};